const convertTypes = {
    preferences: {

    },
    types : {
        sentence: {
            label: 'Sentence Format',
            value: 'sentence'
        },
        title: {
            label: 'Title Format',
            value: 'title'
        },
        uppercase: {
            label: 'UPPERCASE',
            value: 'uppercase'
        },
        lowercase: {
            label: 'lowercase',
            value: 'lowercase'
        },
    }
}

export default convertTypes;


// WEBPACK FOOTER //
// ./src/config/convertTypes.js